import { Axios } from "@/utils/axios";

export const postScrap = (id: number) => {
  return Axios.post(`/questions/${id}/scrap/`);
};
